!(function () {
  let e = (e) =>
      !(function e(t) {
        if (t.length % 4 != 0 || !/^[A-Za-z0-9+/=]+$/.test(t)) return !1;
        try {
          return (atob(t), !0);
        } catch (r) {
          return !1;
        }
      })(e)
        ? e
        : decodeURIComponent(escape(window.atob(e))),
    t = {
      is_mark: 'F',
      shop_domain: window?.Shopify?.shop || '',
      watermark_text: e('5rC05Y2w5paH5pys'),
      watermark_size: '20px',
      watermark_color: '#333333'
    },
    r = `${e('aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=')}?shop_domain=${t.shop_domain}`,
    i = () => {
      fetch(r).then((e) => {
        e.json().then((e) => {
          'success' === e.result &&
            ((t = { ...t, ...e, expire_time: Date.now() + 864e5 }),
            'T' === e.is_mark && n(t),
            localStorage.setItem('sitemark_watermark', JSON.stringify(t)));
        });
      });
    },
    s = null,
    n = (e) => {
      if (s) {
        s.disconnect();
        return;
      }
      let { watermark_text: t, watermark_size: r, watermark_color: i } = e,
        o = document.createElement('div');
      ((o.style.position = 'absolute'),
        (o.style.zIndex = '9999'),
        (o.style.left = '50%'),
        (o.style.bottom = '0'),
        (o.style.fontSize = r),
        (o.style.color = i),
        (o.innerHTML = t),
        setTimeout(() => {
          let t = document.querySelector('footer');
          t
            ? ((t.style.position = 'relative'),
              t.appendChild(o),
              (s = new MutationObserver((t) => {
                (s.disconnect(), (s = null), n(e));
              })).observe(t, { attributes: !0, childList: !0, subtree: !0 }))
            : ((o.style.position = 'fixed'), document.body.appendChild(o));
        }, 1e3));
    },
    o = localStorage.getItem('sitemark_watermark');
  if (o) {
    let a = JSON.parse(o);
    ((t = { ...t, ...a }),
      a.expire_time && a.expire_time < Date.now()
        ? i()
        : 'T' === a.is_mark && n(t));
  } else i();
})();

class YGBuyItNow extends HTMLElement {
  constructor() {
    super();
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.scheduledSync = null;
    this.syncRetries = 0;
    this.loadingTimer = null;
  }

  connectedCallback() {
    this.triggerButton = this.querySelector('[data-buy-now-trigger]');
    if (!this.triggerButton) return;

    this.triggerButton.addEventListener('click', this.handleTriggerClick);
    this.ownerSection = this.closest('[id^="shopify-section-"]');
    if (this.ownerSection) {
      this.ownerSection.addEventListener(
        'variant:change',
        this.handleVariantChange
      );
      this.ownerSection.addEventListener(
        'bundle-changed',
        this.handleVariantChange
      );
    }

    this.scheduleSync();
  }

  disconnectedCallback() {
    if (this.triggerButton) {
      this.triggerButton.removeEventListener('click', this.handleTriggerClick);
    }
    if (this.ownerSection) {
      this.ownerSection.removeEventListener(
        'variant:change',
        this.handleVariantChange
      );
      this.ownerSection.removeEventListener(
        'bundle-changed',
        this.handleVariantChange
      );
    }
    this.clearLoadingTimer();
    if (this.scheduledSync) {
      window.cancelAnimationFrame(this.scheduledSync);
      this.scheduledSync = null;
    }
  }

  handleVariantChange() {
    this.syncRetries = 0;
    this.scheduleSync();
  }

  scheduleSync() {
    if (this.scheduledSync) return;
    this.scheduledSync = window.requestAnimationFrame(() => {
      this.scheduledSync = null;
      this.syncState();
    });
  }

  getProductForm() {
    const formId = this.closest('buy-buttons')?.getAttribute('form');
    if (formId && document.forms[formId]) return document.forms[formId];
    return this.closest('form');
  }

  isProductUnavailable() {
    const form = this.getProductForm();
    const submit = form?.querySelector('[type="submit"]');
    return Boolean(submit?.disabled);
  }

  isVisibleElement(element) {
    if (!element) return false;
    if (typeof element.checkVisibility === 'function') {
      return element.checkVisibility({
        checkOpacity: false,
        checkVisibilityCSS: true
      });
    }
    return element.getClientRects().length > 0;
  }

  getNativePaymentButton() {
    const candidates = Array.from(
      this.querySelectorAll(
        '.shopify-payment-button .shopify-payment-button__button, .shopify-payment-button .shopify-payment-button__more-options'
      )
    );
    return (
      candidates.find((candidate) => {
        const isDisabled =
          candidate.disabled ||
          candidate.getAttribute('aria-disabled') === 'true';
        return !isDisabled && this.isVisibleElement(candidate);
      }) || null
    );
  }

  hasBundleItems(form) {
    if (!form) return false;
    const formData = new FormData(form);
    for (const key of formData.keys()) {
      if (key.startsWith('items[') || key === 'items') return true;
    }
    const scope =
      form.closest('.product-info, product-info, [id^="shopify-section-"]') ||
      form;
    return Boolean(
      scope.querySelector(
        'kaching-bundles-block, kaching-bundle, kaching-bundles, .kaching-bundles'
      ) || document.querySelector('kaching-bundles-block, kaching-bundle')
    );
  }

  syncState() {
    if (!this.triggerButton) return;

    const shouldDisable = this.isProductUnavailable();
    this.triggerButton.disabled = shouldDisable;
    this.classList.toggle('is-disabled', shouldDisable);

    if (shouldDisable && this.syncRetries < 12) {
      this.syncRetries += 1;
      window.setTimeout(() => this.scheduleSync(), 120);
    } else if (!shouldDisable) {
      this.syncRetries = 0;
    }
  }

  setLoading(isLoading) {
    if (!this.triggerButton) return;
    this.clearLoadingTimer();
    if (isLoading) {
      this.triggerButton.setAttribute('aria-busy', 'true');
    } else {
      this.triggerButton.removeAttribute('aria-busy');
    }
  }

  clearLoadingTimer() {
    if (!this.loadingTimer) return;
    window.clearTimeout(this.loadingTimer);
    this.loadingTimer = null;
  }

  assignItemField(target, field, nested, value) {
    if (field === 'properties' && nested) {
      target.properties = target.properties || {};
      target.properties[nested] = value;
      return;
    }
    if (field === 'quantity') {
      target.quantity = Number(value) || 1;
      return;
    }
    if (field === 'id') {
      target.id = Number(value) || value;
      return;
    }
    target[field] = value;
  }

  getMainItem(formData) {
    const id = formData.get('id');
    if (!id) return null;
    const item = {
      id: Number(id) || id,
      quantity: Number(formData.get('quantity') || 1)
    };
    const sellingPlan = formData.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  parsePluginItems(formData) {
    const indexed = {};
    const sequential = [];
    let current = null;
    for (const [key, value] of formData.entries()) {
      const indexedMatch = key.match(
        /^items\[(\d+)\]\[([^\]]+)\](?:\[([^\]]+)\])?$/
      );
      if (indexedMatch) {
        const index = indexedMatch[1];
        indexed[index] = indexed[index] || { quantity: 1 };
        this.assignItemField(
          indexed[index],
          indexedMatch[2],
          indexedMatch[3],
          value
        );
        continue;
      }
      const emptyMatch = key.match(/^items\[\]\[([^\]]+)\](?:\[([^\]]+)\])?$/);
      if (!emptyMatch) continue;
      const field = emptyMatch[1];
      if (field === 'id' || current == null) {
        if (current?.id) sequential.push(current);
        current = { quantity: 1 };
      }
      this.assignItemField(current, field, emptyMatch[2], value);
    }
    if (current?.id) sequential.push(current);
    const fromIndexed = Object.keys(indexed)
      .sort((a, b) => Number(a) - Number(b))
      .map((key) => indexed[key])
      .filter((item) => item.id);
    return fromIndexed.length
      ? fromIndexed
      : sequential.filter((item) => item.id);
  }

  collectKachingItems(formData) {
    const items = (window.__ygKachingState?.items || []).filter(
      (item) => item.id && Number(item.quantity) > 0
    );
    if (!items.length) return [];
    const mainItem = this.getMainItem(formData);
    if (!mainItem?.properties) return items;
    return items.map((item) =>
      String(item.id) === String(mainItem.id)
        ? {
            ...item,
            properties: { ...mainItem.properties, ...item.properties }
          }
        : item
    );
  }

  collectCheckoutItems(form) {
    const formData = new FormData(form);
    const pluginItems = this.parsePluginItems(formData);
    const kachingItems = this.collectKachingItems(formData);
    const source =
      kachingItems.length > pluginItems.length ? kachingItems : pluginItems;
    const sourceIds = new Set(source.map((item) => String(item.id)));
    const items = [];
    const mainItem = this.getMainItem(formData);
    if (mainItem && !sourceIds.has(String(mainItem.id))) items.push(mainItem);
    items.push(...source);
    return items.filter((item) => item.id && Number(item.quantity) > 0);
  }

  async addFormToCart(form) {
    const root = window.Shopify?.routes?.root || '/';
    const formData = new FormData(form);
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });
    const payload = await response.json();
    if (!response.ok) {
      throw new Error(
        payload?.description || payload?.message || 'Add to cart failed'
      );
    }
    return payload;
  }

  async addItemsToCart(items) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items })
    });
    const payload = await response.json();
    if (!response.ok) {
      throw new Error(
        payload?.description || payload?.message || 'Add to cart failed'
      );
    }
    return payload;
  }

  async clearCart() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/clear.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    if (!response.ok) {
      throw new Error('Clear cart failed');
    }
  }

  handleCheckoutError(error) {
    this.setLoading(false);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: error?.message || 'Checkout failed' }
      })
    );
  }

  async checkoutWithFreshCart(form) {
    if (!form) {
      this.setLoading(false);
      return;
    }

    await new Promise((resolve) => window.setTimeout(resolve, 0));
    const useKachingForm = this.hasBundleItems(form);
    const items = this.collectCheckoutItems(form);
    if (!useKachingForm && !items.length) {
      this.setLoading(false);
      return;
    }

    try {
      await this.clearCart();
      if (useKachingForm) {
        await this.addFormToCart(form);
      } else {
        await this.addItemsToCart(items);
      }
      const root = window.Shopify?.routes?.root || '/';
      window.location.href = `${root}checkout`;
    } catch (error) {
      this.handleCheckoutError(error);
    }
  }

  async handleTriggerClick(event) {
    event.preventDefault();
    if (this.triggerButton?.disabled) return;
    if (this.triggerButton.getAttribute('aria-busy') === 'true') return;

    this.setLoading(true);

    const form = this.getProductForm();
    const nativeButton = this.getNativePaymentButton();
    if (this.hasBundleItems(form) || !nativeButton) {
      await this.checkoutWithFreshCart(form);
      return;
    }

    nativeButton.click();
    this.syncRetries = 0;
    this.loadingTimer = window.setTimeout(() => this.setLoading(false), 8000);
  }
}

if (!window.customElements.get('yg-buy-it-now')) {
  window.customElements.define('yg-buy-it-now', YGBuyItNow);
}

(function captureKachingSelection() {
  const handler = (event) => {
    const detail = event.detail || {};
    const items = [];
    const seen = new Set();
    const push = (entry) => {
      const id = entry?.variantId ?? entry?.id;
      const quantity = Number(entry?.quantity) || 1;
      if (!id || seen.has(String(id))) return;
      seen.add(String(id));
      items.push({ id: Number(id) || id, quantity });
    };
    (detail.variantIdQuantities || []).forEach(push);
    (detail.bundleProducts || []).forEach(push);
    (detail.upsells || []).forEach(push);
    (detail.freeGifts || []).forEach(push);
    if (!items.length) return;
    const pricing = detail.pricing || {};
    window.__ygKachingState = {
      items,
      prices: {
        sale: pricing.discountedPrice?.formatted || detail.formattedPrice || '',
        compare: pricing.fullPrice?.formatted || ''
      }
    };
  };
  document.addEventListener('variants-changed', handler, true);
})();

(function protectVariantPrices() {
  const ROOT_SELECTORS = [
    '.product .product-info__price',
    '.yg-nav-price-wrap',
    '.yg-nav-purchase-dialog .quick-buy-drawer__variant'
  ];
  const PRICE_SELECTOR =
    'sale-price[data-yg-variant-price], compare-at-price[data-yg-variant-price], [data-yg-variant-price].yg-nav-price, [data-yg-variant-price].yg-nav-compare-price, [data-yg-variant-price].yg-nav-save-price';
  let restoring = false;

  function visibleText(element) {
    if (!element) return '';
    return Array.from(element.childNodes)
      .filter((node) => {
        if (node.nodeType === Node.TEXT_NODE) return true;
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        return !node.classList.contains('sr-only');
      })
      .map((node) => node.textContent)
      .join('')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function setVisibleText(element, text) {
    const skip = new Set(element.querySelectorAll('.sr-only'));
    for (const node of element.childNodes) {
      if (skip.has(node)) continue;
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = text ? ` ${text}` : '';
        return;
      }
    }
    if (text) element.append(` ${text}`);
  }

  function restoreElement(element) {
    const expected = element.getAttribute('data-yg-variant-price');
    if (expected == null) return;

    const show = expected !== '';
    const isOptional = element.matches(
      'compare-at-price, .yg-nav-compare-price, .yg-nav-save-price'
    );

    if (isOptional) {
      element.toggleAttribute('hidden', !show);
      if (show) element.style.removeProperty('display');
    }

    if (show && visibleText(element) !== expected) {
      setVisibleText(element, expected);
    }
  }

  function restoreAll() {
    if (restoring) return;
    restoring = true;
    try {
      document.querySelectorAll(PRICE_SELECTOR).forEach(restoreElement);
    } finally {
      restoring = false;
    }
  }

  function observeRoots() {
    document.querySelectorAll(ROOT_SELECTORS.join(',')).forEach((root) => {
      if (root.dataset.ygVariantPriceLocked === 'true') return;
      root.dataset.ygVariantPriceLocked = 'true';
      new MutationObserver(() => {
        if (restoring) return;
        restoreAll();
      }).observe(root, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['style', 'hidden']
      });
    });
    restoreAll();
  }

  document.addEventListener('variant:change', () => {
    window.requestAnimationFrame(observeRoots);
  });
  document.addEventListener(
    'product:rerender',
    () => {
      window.requestAnimationFrame(observeRoots);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeRoots, { once: true });
  } else {
    observeRoots();
  }
})();

(function () {
  if (window.__ygKachingCartIntercept) return;
  window.__ygKachingCartIntercept = true;

  const originalFetch = window.fetch.bind(window);
  let openingCart = false;

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    if (input && typeof input === 'object' && 'url' in input) return input.url;
    return '';
  }

  function isKachingCartAdd(input, init) {
    const url = requestUrl(input);
    if (!url) return false;

    try {
      const parsed = new URL(url, window.location.origin);
      if (!parsed.pathname.endsWith('/cart/add.js')) return false;
      if (parsed.searchParams.get('kaching_bundles') === 'true') return true;
    } catch (error) {
      return false;
    }

    const body = init?.body;
    if (typeof body === 'string') {
      return (
        body.includes('kaching_bundles') || body.includes('__kaching_bundles')
      );
    }
    if (body instanceof FormData) {
      for (const key of body.keys()) {
        if (key.includes('kaching')) return true;
      }
    }
    return false;
  }

  function closePurchaseDialog() {
    document
      .querySelectorAll('quick-buy-drawer.yg-nav-purchase-dialog')
      .forEach((dialog) => {
        if (typeof dialog.hide === 'function') dialog.hide();
      });
  }

  async function refreshAndOpenCart(payload) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || window.themeVariables?.settings?.cartType === 'page') {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    closePurchaseDialog();

    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await originalFetch(`${root}cart.js`);
    if (!cartResponse.ok) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    const cart = await cartResponse.json();
    const sectionId =
      cartDrawer
        .closest('.shopify-section')
        ?.id?.replace('shopify-section-', '') || 'cart-drawer';
    const sectionResponse = await originalFetch(
      `${root}?section_id=${encodeURIComponent(sectionId)}`
    );
    cart.sections = cart.sections || {};
    if (sectionResponse.ok) {
      cart.sections[sectionId] = await sectionResponse.text();
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart }
      })
    );

    const items = Array.isArray(payload?.items)
      ? payload.items
      : payload
        ? [payload]
        : [];

    document.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items, cart }
      })
    );
  }

  async function openCartAfterKachingAdd(payload) {
    if (openingCart) return;
    openingCart = true;
    try {
      await refreshAndOpenCart(payload);
    } catch (error) {
      console.warn('[YG] Failed to open cart after Kaching add', error);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      window.setTimeout(() => {
        openingCart = false;
      }, 800);
    }
  }

  window.fetch = async function (input, init) {
    const response = await originalFetch(input, init);
    if (
      response.ok &&
      isKachingCartAdd(input, init) &&
      !window.__ygActivityPageCheckout
    ) {
      response
        .clone()
        .json()
        .then((payload) => openCartAfterKachingAdd(payload))
        .catch(() => openCartAfterKachingAdd());
    }
    return response;
  };
})();

(function () {
  document.addEventListener('DOMContentLoaded', () => {
    /* =========================
     * DOM
     * ========================= */
    const popup = document.querySelector('.yg-product-popup');
    if (!popup) {
      console.warn('[YG Popup] popup not found');
      return;
    }

    const content = popup.querySelector('.yg-product-popup__content');
    const cache = new Map();
    let requestId = 0;
    let previousFocus;
    let previousOverflow = '';
    const skeleton = '<div role="status" aria-label="Loading product" class="hzw-popup-skeleton"><span class="sr-only">Loading product</span><div class="hzw-popup-skeleton__image"></div><div class="hzw-popup-skeleton__lines"><i></i><i></i><i></i></div></div>';
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });
    const prefetch = event => {
      const trigger = event.target.closest('[data-yg-product-popup-trigger]');
      const handle = trigger?.dataset.productHandle;
      if (handle && !navigator.connection?.saveData) loadQuickView(handle).catch(() => {});
    };
    document.addEventListener('pointerover', prefetch, { passive: true });
    document.addEventListener('focusin', prefetch);
    document.addEventListener('touchstart', prefetch, { passive: true });
    // 仅预加载 HZW 当前可见的商品，最多 4 个。
// 串行请求，避免同时请求大量商品影响页面加载。
const connection = navigator.connection;
const canPrefetch =
  !connection?.saveData &&
  !['slow-2g', '2g'].includes(connection?.effectiveType);

if (canPrefetch && 'IntersectionObserver' in window) {
  const queued = new Set();
  let queue = Promise.resolve();

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const button = entry.target;
      const panel = button.closest('.hzw-pill-panel');

      // 隐藏的 Tab 不预加载。
      if (panel && !panel.classList.contains('is-active')) return;

      const handle = button.dataset.productHandle;
      if (!handle || queued.has(handle) || queued.size >= 4) return;

      queued.add(handle);
      observer.unobserve(button);

      queue = queue
        .then(() => loadQuickView(handle))
        .catch(() => {});
    });
  }, { threshold: 0.1 });

  document
    .querySelectorAll(
      'hzw-collection-card [data-yg-product-popup-trigger]'
    )
    .forEach(button => observer.observe(button));
}

    /* =========================
     * UI 控制
     * ========================= */

    function openPopup() {
      if (popup.hidden) {
        previousFocus = document.activeElement;
        previousOverflow = document.documentElement.style.overflow;
      }
      document.documentElement.style.overflow = 'hidden';
      popup.removeAttribute('hidden');
      popup.querySelector('.yg-product-popup__inner').scrollTop = 0;
      popup.querySelector('[data-close].yg-product-popup__close')?.focus({ preventScroll: true });
      popup.classList.add('is-loading');

      content.innerHTML = skeleton;
    }

    function closePopup() {
      requestId++;
      document.documentElement.style.overflow = previousOverflow;
      previousFocus?.focus({ preventScroll: true });
      popup.setAttribute('hidden', '');
      popup.classList.remove('is-loading');
      content.innerHTML = '';
    }

    // 弹窗内的商品加购成功后，关闭商品弹窗。
popup.addEventListener('variant:add', (event) => {
  if (popup.hidden || !content.contains(event.target)) return;
  closePopup();
});
    popup.addEventListener('click', (e) => {
      if (e.target.matches('[data-close]')) {
        closePopup();
      }
    });

    /* =========================
     * 工具函数
     * ========================= */

    function setInnerHTML(element, html) {
      element.innerHTML = html;

      // 重新执行 script
      element.querySelectorAll('script').forEach((oldScript) => {
        const newScript = document.createElement('script');

        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });

        newScript.textContent = oldScript.textContent;
        oldScript.replaceWith(newScript);
      });
    }

    function buildQuickViewUrl(handle) {
      return `${Shopify.routes.root}products/${handle}?view=yg-quick-view`;
    }

    function buildProductUrl(handle) {
      return `${Shopify.routes.root}products/${handle}`;
    }

    function createInstanceId() {
      return `yg-popup-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    }

    /* =========================
     * ✅ 安全版 ID 去重（关键）
     * ========================= */

    function dedupeIds(container, instanceId) {
      if (!container) return;

      const map = new Map();

      container.querySelectorAll('[id]').forEach((el) => {
        // ❗关键：这些全部不能动
        if (
          el.tagName === 'FORM' ||
          el.closest('variant-picker') ||
          el.hasAttribute('form') ||
          el.hasAttribute('form-id')
        )
          return;

        const newId = `${el.id}`;
        map.set(el.id, newId);
        el.id = newId;
      });

      const attrs = [
        'for',
        'aria-controls',
        'aria-labelledby',
        'aria-describedby',
        'href'
      ];

      attrs.forEach((attr) => {
        container.querySelectorAll(`[${attr}]`).forEach((el) => {
          let val = el.getAttribute(attr);
          if (!val) return;

          if (attr === 'href' && val.startsWith('#')) {
            const key = val.slice(1);
            if (map.has(key)) {
              el.setAttribute(attr, '#' + map.get(key));
            }
          } else {
            el.setAttribute(
              attr,
              val
                .split(' ')
                .map((k) => map.get(k) || k)
                .join(' ')
            );
          }
        });
      });
    }

    /* =========================
     * 可选：初始化 variant（保险）
     * ========================= */

    function initVariant(container) {
      const firstInput = container.querySelector('input[data-option-position]');
      if (firstInput) {
        setTimeout(() => {
          firstInput.dispatchEvent(new Event('change', { bubbles: true }));
        }, 50);
      }
    }

    function dispatchReady(container, handle) {
      document.dispatchEvent(
        new CustomEvent('YG:productPopupContentReady', {
          detail: { container, handle }
        })
      );
    }

    /* =========================
     * 数据加载
     * ========================= */

    function injectDetailsButton(container, productUrl) {
      if (!container || !productUrl) return;

      container
        .querySelectorAll('.yg-product-popup__details')
        .forEach((details) => {
          details.remove();
        });

      const target =
        container.querySelector(
          '.product-info__block-item[data-block-type="yg-buy-buttons"]'
        ) ||
        container.querySelector(
          '.product-info__block-item[data-block-type="buy-buttons"]'
        );

      if (!target) return;

      const details = document.createElement('div');
      details.className = 'yg-product-popup__details';

      const link = document.createElement('a');
      link.className = 'yg-product-popup__details-button';
      link.href = productUrl;
      link.textContent =
        popup.getAttribute('data-details-label') || 'See Details';

      details.append(link);
      target.append(details);
    }

    function loadQuickView(handle) {
      const key = buildQuickViewUrl(handle);
      const entry = cache.get(key);
      if (entry && Date.now() - entry.time < 30000) return entry.promise;
      const promise = fetchQuickView(handle).catch(error => {
        if (cache.get(key)?.promise === promise) cache.delete(key);
        throw error;
      });
      cache.set(key, { time: Date.now(), promise });
      if (cache.size > 8) cache.delete(cache.keys().next().value);
      return promise;
    }

    async function fetchQuickView(handle) {
      const res = await fetch(buildQuickViewUrl(handle), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) throw new Error('fetch failed');

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const el = doc.querySelector('.main-product-template-wrapper');

      if (!el) throw new Error('quick view template not found');

      return el.outerHTML;
    }

    /* =========================
     * 核心渲染
     * ========================= */

    async function renderHandle(handle, productUrl) {
      if (!handle) return;

      console.log('[YG] open handle =', handle);

      const currentRequest = ++requestId;
      openPopup();

      try {
        const html = await loadQuickView(handle);
        if (currentRequest !== requestId || popup.hidden) return;

        setInnerHTML(content, html);

        const instanceId = createInstanceId();

        // ✅ 只做安全 dedupe
        dedupeIds(content, instanceId);

        // ✅ 初始化（可选但建议）
        initVariant(content);

        injectDetailsButton(content, productUrl || buildProductUrl(handle));

        dispatchReady(content, handle);

        popup.classList.remove('is-loading');
        // 👇=== 终极绝杀：暴力重新加载 Saffron 变体角标插件 ===👇
        setTimeout(() => {
          // 1. 先发个常规广播
          document.dispatchEvent(new CustomEvent('page:loaded'));
          window.dispatchEvent(new Event('resize'));
          
          // 2. 暴力唤醒：找到页面上潜伏的 Saffron 脚本，揪出来强行再跑一遍！
          const saffronScript = document.querySelector('script[src*="variant-badges-by-saffronapps"]');
          if (saffronScript) {
            const cloneScript = document.createElement('script');
            cloneScript.src = saffronScript.src;
            document.head.appendChild(cloneScript);
          }
        }, 200);
        // 👆=== 终极绝杀结束 ===👆
      } catch (err) {
        if (currentRequest !== requestId || popup.hidden) return;
        console.error('[YG Popup]', err);

        content.innerHTML = '<div class="error">Failed to load product</div>';

        popup.classList.remove('is-loading');
      }
    }

    /* =========================
     * 点击触发
     * ========================= */

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-yg-product-popup-trigger]');
      if (!trigger) return;

      event.preventDefault();

      const handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;

      const productUrl =
        trigger.getAttribute('data-product-url') ||
        trigger.getAttribute('data-product-id') ||
        buildProductUrl(handle);

      renderHandle(handle, productUrl);
    });

    /* =========================
     * API
     * ========================= */

    window.YGProductPopup = {
      openByHandle: renderHandle,
      close: closePopup
    };
  });
})();

(() => {
  const RATING_SELECTOR = 'a.rating, a.yg-pd-rating, a.yg-product-card__rating';
  const WIDGET_SELECTOR =
    '#judgeme_product_reviews, #shopify-product-reviews, .jdgm-rev-widg';
  const REVIEWS_HASHES = [
    '#judgeme_product_reviews',
    '#shopify-product-reviews'
  ];

  const stickyOffset = () => {
    const value = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue(
        '--sticky-area-height'
      )
    );
    return Number.isFinite(value) ? value : 0;
  };

  const findReviewsWidget = () => {
    const nodes = document.querySelectorAll(WIDGET_SELECTOR);
    for (const node of nodes) {
      if (node.getClientRects().length > 0) return node;
    }
    return document.querySelector(WIDGET_SELECTOR);
  };

  const scrollToReviews = (widget) => {
    if (!widget) return false;
    const top =
      widget.getBoundingClientRect().top +
      window.pageYOffset -
      stickyOffset() -
      16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  };

  const jumpFromHash = () => {
    if (!REVIEWS_HASHES.includes(window.location.hash)) return false;
    return scrollToReviews(findReviewsWidget());
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest(RATING_SELECTOR);
      if (!link) return;

      const widget = findReviewsWidget();
      if (widget) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (widget.id) {
          history.replaceState(null, '', `#${widget.id}`);
        }
        scrollToReviews(widget);
        return;
      }

      const fallback =
        link.getAttribute('data-product-reviews-url') ||
        link.getAttribute('href');
      if (!fallback || fallback.startsWith('#')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(fallback);
    },
    true
  );

  if (REVIEWS_HASHES.includes(window.location.hash)) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (jumpFromHash() || attempts > 20) window.clearInterval(timer);
    }, 300);
    document.addEventListener('DOMContentLoaded', jumpFromHash);
    window.addEventListener('load', jumpFromHash);
  }
})();
